module.exports = __webpack_public_path__ + "img/232001b.jpg";